import { render, staticRenderFns } from "./SalePropTable.vue?vue&type=template&id=2f739ea2&scoped=true"
import script from "./SalePropTable.vue?vue&type=script&lang=js"
export * from "./SalePropTable.vue?vue&type=script&lang=js"
import style0 from "./SalePropTable.vue?vue&type=style&index=0&id=2f739ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f739ea2",
  null
  
)

export default component.exports